import { LBCheckIcon, LBXIcon } from '@linearb/buzz';
import { isBoolean } from 'lodash';

const ValidationStatusIcon = ({ isValid }) => {
  if (!isBoolean(isValid)) return null;
  const Icon = isValid ? LBCheckIcon : LBXIcon;

  return (
    <Icon
      className={`text-base ${isValid ? 'text-success' : 'text-destructive'}`}
    />
  );
};

export default ValidationStatusIcon;
